import { Box, CircularProgress } from '@mui/material';
import React, { Suspense } from 'react';
import { useGetBenchmarkingQuery, useGetBenchmarkOverwriteQuery, useGetPortfolioAnalysisHeatQuery, useGetPortfolioAnalysisPowerQuery, useGetPortfolioAnalysisSubscriptionQuery, useGetPortfolioAnalysisWaterQuery } from '../../../../api/energy-analysis/portfolioAnalysisApiSlice';

const PortfolioAnalysisManagementDrawer = React.lazy(() =>
    import('remote/PortfolioAnalysisManagementDrawer').catch(() => ({
      default: () => <div>Failed to load</div>,
    }))
  );

const PortfolioAnalysisDrawerContainer = ({ isOpen, onClose, account }) => {

  const { data: subscriptionData } = useGetPortfolioAnalysisSubscriptionQuery({recalc_account_id: account.AccountId}, { skip: !account?.AccountId});

  const { data: powerData, error: powerError, isLoading: isPowerLoading, isFetching: isPowerFetching } = useGetPortfolioAnalysisPowerQuery({ recalc_account_id: account?.AccountId }, { skip: !account?.AccountId });
  const { data: waterData, error: waterError, isLoading: isWaterLoading, isFetching: isWaterFetching } = useGetPortfolioAnalysisWaterQuery({ recalc_account_id: account?.AccountId }, { skip: !account?.AccountId });
  const { data: heatData, error: heatError, isLoading: isHeatLoading, isFetching: isHeatFetching } = useGetPortfolioAnalysisHeatQuery({ recalc_account_id: account?.AccountId }, { skip: !account?.AccountId });

  const { data: benchmarkData, isError: benchmarkError, isLoading: benchmarkLoading, isFetching: benchmarkFetching } = useGetBenchmarkingQuery({ recalc_account_id: account?.AccountId }, { skip: !account?.AccountId })
  const { data: benchmarkOverwriteData, isError: isBenchmarkOverwriteError, isLoading: isBenchmarkOverwriteLoading } = useGetBenchmarkOverwriteQuery({ account_id: account?.AccountId }, { skip: !account?.AccountId });

  return (
    <Suspense fallback={
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', verticalAlign: 'center' }}>
        <CircularProgress />
      </Box>
    }>
          <PortfolioAnalysisManagementDrawer account={{...account, 
          jsonObjects: 
            [
              {object: subscriptionData, name: 'Subscriptions'},
              {object: powerData, name: 'Power', nameKey: 'address'},
              {object: waterData, name: 'Water', nameKey: 'address'},
              {object: heatData, name: 'Heat', nameKey: 'address'},
              {object: benchmarkData, name: 'Benchmark', nameKey: 'MatrikelKey'},
              {object: benchmarkOverwriteData, name: 'Benchmark Overwrite', nameKey: 'MatrikelKey'},

              ]}} open={isOpen} onClose={onClose}  />
      </Suspense>
  );
};

export default PortfolioAnalysisDrawerContainer;